import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import LocalizedStrings from "react-localization";
import locale from "./locale/localization.json";
import Navbar from "./Navbar";
import ImageEditor from "./ImageEditor";
import ProductOptions from "./ProductOptions";
import queryString from "query-string";
import "./Visualizer.css";

const Configuration = require("./shared/configuration");

class Visualizer extends Component {
  constructor(props) {
    super(props);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.strings = new LocalizedStrings(locale);
    this.strings.setLanguage(this.props.match.params.language);
    this.query = queryString.parse(props.location.search);
  }

  handleLanguageChange(lang) {
    this.props.history.push(
      Configuration.configurationToUrl(
        Configuration.configurationWithChanges(
          Configuration.configurationFromMatch(this.props.match),
          [{ language: lang }]
        )
      )
    );
    this.strings.setLanguage(lang);
  }

  render() {
    const { params } = this.props.match;
    const configuration = Configuration.configurationFromMatch(
      this.props.match
    );

    return (
      <div>
        <Navbar
          lang={configuration.language}
          changeLannguage={this.handleLanguageChange}
          strings={this.strings}
        />
        <div className="Visualizer">
          <ProductOptions
            conf={configuration}
            match={params}
            strings={this.strings}
          />
          <ImageEditor configuration={configuration} strings={this.strings} />
        </div>
      </div>
    );
  }
}
export default withRouter(Visualizer);



// WEBPACK FOOTER //
// ./src/Visualizer.js